export { PLPPage as default } from './PLPPage';
